import React from "react";

const Watsapp = () => {
	return (
		<div className='fixed w-[25vw] md:w-[10vw] bottom-[1px] right-[1px] cursor-pointer z-50'>
			<a href='https://wa.me/+5492664463274' target={"blank"}>
				<img
					src='https://res.cloudinary.com/drhj3sc2o/image/upload/v1678307454/WhatsApp-Logo.wine_cugmui.svg'
					alt='logo wpp'
				/>
			</a>
		</div>
	);
};

export default Watsapp;
